export default "__VITE_ASSET__DdrIfTGF__"